import { Box, Button, Center, Code, Group, Stack, Text, Title } from '@mantine/core'
import { LuLifeBuoy, LuRefreshCw } from 'react-icons/lu'
import { DepthContour } from './marina/DepthContour'
import { EmptyState } from './marina/EmptyState'

/**
 * Error fallback — Pelabuhan styled "rough seas" page.
 * Life-ring illustration on depth-contour backdrop. Maritime metaphor for
 * "something went wrong, here's the safety equipment".
 */
export function ErrorPage({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : 'Terjadi kesalahan yang tidak terduga'

  return (
    <Box style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          color: 'var(--mantine-color-karang-6)',
        }}
      >
        <DepthContour size={900} opacity={0.1} rings={8} />
      </Box>

      <Center mih="100vh" style={{ position: 'relative' }}>
        <Stack align="center" gap="md" maw={520} px="md">
          <EmptyState kind="lifering" size="lg" backdrop={false} title="" description="" />

          <Stack gap={6} align="center">
            <Text size="xs" tt="uppercase" c="dimmed" fw={600} style={{ letterSpacing: '0.18em' }}>
              500 · Ombak Besar
            </Text>
            <Title
              order={1}
              ta="center"
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                fontWeight: 600,
                letterSpacing: '-0.02em',
                lineHeight: 1.1,
              }}
            >
              Kapal kami terkena badai
            </Title>
            <Text c="dimmed" size="sm" ta="center" maw={420}>
              Terjadi kesalahan tak terduga. Tim kami sedang menggulung layar — coba muat ulang.
            </Text>
          </Stack>

          <Code block c="red" style={{ maxWidth: '100%', wordBreak: 'break-word', fontSize: '0.75rem' }}>
            {message}
          </Code>

          <Group gap="sm">
            <Button onClick={() => window.location.reload()} leftSection={<LuRefreshCw size={16} />} color="laut">
              Muat Ulang
            </Button>
            <Button
              onClick={() => {
                window.location.href = '/'
              }}
              leftSection={<LuLifeBuoy size={16} />}
              variant="default"
            >
              Ke Beranda
            </Button>
          </Group>
        </Stack>
      </Center>
    </Box>
  )
}
